export default function CMathH() {
  return <h2>C Math H</h2>;
}
